import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=d4de063a"
import script from "./ClipboardCopy.vue?vue&type=script&lang=js"
export * from "./ClipboardCopy.vue?vue&type=script&lang=js"
import style0 from "./ClipboardCopy.vue?vue&type=style&index=0&id=d4de063a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports